import {z} from 'zod';

import i18n from '@dms/i18n';

export const BrandFormSchema = z.object({
  name: z
    .string({
      required_error: i18n.t('general.validations.fieldIsRequired'),
    })
    .trim()
    .min(1, i18n.t('general.validations.fieldIsRequired')),
});

export type BrandFormType = z.infer<typeof BrandFormSchema>;
